import React from 'react';
import styles from '../OrderDetailsModal.module.scss';
import ButtonWithIcon from 'components/ButtonWithIcon';
// import {BellIcon, CreditCardIcon} from '../icons';
import { BanknoteIcon } from 'pages/RequestDetails/components/icons/banknote';
import { formatPrice } from 'utils/format-price';

interface Payment {
  totalAmount: number;
  totalPaid: number;
  amountDue: number;
}

interface PayableInfoProps {
  payment: Payment;
  // onNotifyToPay?: () => void;
  // onCharge?: () => void;
  onChargeManually?: () => void;
  // isNotifyToPayDisabled?: boolean;
  isManualChargeDisabled?: boolean;
  // isChargeDisabled?: boolean;
}

const PayableInfo: React.FC<PayableInfoProps> = ({
  payment,
  // onNotifyToPay,
  // onCharge,
  onChargeManually,
  // isNotifyToPayDisabled,
  isManualChargeDisabled,
  // isChargeDisabled,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Money Out</h2>
      </div>

      <div className={styles.paymentGrid}>
        <div className={styles.paymentItem}>
          <div className={styles.paymentLabel}>Total amount</div>
          <div className={`${styles.paymentValue} ${styles.totalAmount}`}>
            {formatPrice(payment.totalAmount)}
          </div>
        </div>

        <div className={styles.paymentItem}>
          <div className={styles.paymentLabel}>Total paid</div>
          <div className={`${styles.paymentValue} ${styles.totalPaid}`}>
            {formatPrice(payment.totalPaid)}
          </div>
        </div>

        <div className={styles.paymentItem}>
          <div className={styles.paymentLabel}>Amount due</div>
          <div className={`${styles.paymentValue} ${styles.amountDue}`}>
            {formatPrice(payment.amountDue)}
          </div>
        </div>
      </div>

      <div className={styles.paymentActions}>
        {/* <ButtonWithIcon
          className={styles.notify_action}
          icon={<BellIcon width={16} height={16} />}
          color="ghost"
          size="md"
          onClick={onNotifyToPay}
          disabled={isNotifyToPayDisabled}
        >
          Notify to Pay
        </ButtonWithIcon> */}
        <ButtonWithIcon
          size="md"
          color="ghost"
          onClick={onChargeManually}
          className={styles.notify_action}
          icon={<BanknoteIcon width={16} height={16} />}
          disabled={isManualChargeDisabled}
        >
          Manual Charge
        </ButtonWithIcon>
        {/* <ButtonWithIcon
          className={styles.notify_action}
          icon={<CreditCardIcon width={16} height={16} />}
          color="ghost"
          size="md"
          onClick={onCharge}
          disabled={isChargeDisabled}
        >
          Charge Card
        </ButtonWithIcon> */}
      </div>
    </div>
  );
};

export default PayableInfo;
